import React from 'react';
import { useParams } from 'react-router-dom';

export const EmptyPage = () => {
  const { pagename } = useParams();

  return (
    <>
     <br />
      <h4>
        {pagename}
      </h4>
    </>
  )
}